const WS_SAMPLE_ORIGINS = ['AOLWS', 'LIS']

export const isWsSampleOrigin = origin =>
  WS_SAMPLE_ORIGINS.includes(String(origin || '').trim().toUpperCase())
